import React from 'react';

/**
 * AnimatedTransition Component
 *
 * Simple fade-in animation when content changes.
 * Uses CSS keyframe animation triggered by key change.
 */
const AnimatedTransition = ({ children, transitionKey }) => {
  return (
    <div
      key={transitionKey}
      style={{
        width: '100%',
        animation: 'fadeSlideIn 0.25s ease-out'
      }}
    >
      {children}
      <style>{`
        @keyframes fadeSlideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default AnimatedTransition;
